import React, {useEffect, useState} from 'react';
import Grid from "@material-ui/core/Grid";
import {connect, useSelector} from 'react-redux'
import Card from "@material-ui/core/Card";
import {CardActionArea, CardHeader, Chip} from "@material-ui/core";
import CardContent from "@material-ui/core/CardContent";
import moment from "moment";
import {makeStyles} from "@material-ui/styles";
import Button from "@material-ui/core/Button";
import * as classnames from "classnames";
import Divider from "@material-ui/core/Divider";
const useStyles = makeStyles({
    selected: {
        backgroundColor: '#bbdefb',
    },
    notFound: {
        backgroundColor: '#fcca86',
    },

    notFoundButSelected: {
        backgroundColor: '#ffa726',
    },

});


const SyncTikMates = ({terminations,newHires,updates, notFoundTerminations, onAccept, onDeactivate, onIgnore, type}) => {


    useEffect( () =>  {
        setSelectedChanges(selectedChanges.filter(st=>!notFoundTerminations.includes(st)))
        },
        [notFoundTerminations])

    const [selectedChanges, setSelectedChanges] = useState([])

    const classes = useStyles();

    const selectCard = (card, type) => {
        card.type= type;
        if(selectedChanges.includes(card))
        {
            setSelectedChanges(selectedChanges.filter(s=>s!==card))
        }else {
            setSelectedChanges([...selectedChanges, card])
        }
    }

    // console.log(terminations.filter(t=>!t.member))

    return (
            <div>
                {((!type||type==='termination')&&!!terminations.length)&&<>
                  <h1>{terminations.length} Approved Terminations</h1>
                    <Grid container spacing={2}>
                        {terminations.filter(t=>t.member).map(t =>
                            <Grid item>
                                <Card onClick={() => selectCard(t,'termination')} className={classnames({
                                    [classes.selected]: selectedChanges.includes(t),
                                    [classes.notFound]: notFoundTerminations.includes(t),
                                    [classes.notFoundButSelected]: selectedChanges.includes(t) && notFoundTerminations.includes(t),
                                })}>


                                    <CardHeader title={`${t.member.firstName||t.member.name} ${t.member.fatherName}`}
                                                subheader={`${t.currentTeam?`from ${t.currentTeam}`:''} on ${moment(t.effectiveDate || t.endDate).format('MMMM DD, YYYY')} `}/>
                                    <CardContent>
                                        <Grid container direction="column">
                                            <Grid item>
                                                Employment End
                                                Date <strong>{moment(t.effectiveDate||t.endDate).format('MMMM DD, YYYY')}</strong>

                                            </Grid>
                                            <Grid item>
                                                Reason <strong>{t.reason}</strong>
                                                {!!t.remark && <div>{t.remark}</div>}
                                            </Grid>
                                            <Grid item>

                                                Approved By <strong>{t.approvedBy}</strong>
                                            </Grid>
                                            <Grid item>
                                                mateId: {t.member.mateId}
                                            </Grid>
                                        </Grid>
                                    </CardContent>
                                    <CardActionArea>
                                        <Chip label={t.source}/>
                                    </CardActionArea>


                                </Card>

                            </Grid>)}


                    </Grid>

                </>}
                <Divider/>

                {((!type||type==='newHire')&&!!newHires.length)&&<>
                   <h1> {newHires.length} Approved Hires </h1>
                    <Divider/>
                    <Grid container  spacing={2}>
                        {newHires.map(t =>
                            <Grid item sm={4} xs={6}>
                                <Card fullWidth style={{cursor: 'pointer'}} onClick={() => selectCard(t,'newHire')} className={classnames({
                                    [classes.selected]: selectedChanges.includes(t),
                                    [classes.notFound]: notFoundTerminations.includes(t),
                                    [classes.notFoundButSelected]: selectedChanges.includes(t) && notFoundTerminations.includes(t),
                                })}>


                                    <CardHeader title={`${t.firstName || t.name} ${t.fatherName}`}
                                                subheader={`${t.employmentType || 'FullTime'} Employee in ${t.joinTeam || t.currentTeam || ''}`}/>
                                    <CardContent>
                                        <Grid container direction="column">
                                            <Grid item>
                                                 Starting from <strong>{moment(t.startDate).format('MMMM DD, YYYY')}</strong>
                                            </Grid>
                                             {t.endDate && <Grid item>
                                                 To <strong>{moment(t.endDate).format('MMMM DD, YYYY')}</strong>
                                            </Grid>}
                                            <Grid item>
                                                 {!!t.remark && <div>{t.remark}</div>}
                                            </Grid>
                                            <Grid item>
                                                Salary: <strong> {t.earning && t.earning.rate} / {t.earning && t.earning.period} </strong>
                                            </Grid>
                                            <Grid item>

                                                Approved By <strong>{t.approvedBy}</strong>
                                            </Grid>
                                            <Grid item>
                                                mateId: {t.mateId}
                                            </Grid>
                                        </Grid>
                                    </CardContent>
                                    <CardActionArea>
                                        <Chip label={t.source}/>
                                        {t.employmentType&&t.employmentType!=='FullTime'&&<Chip color={"primary"} label={t.employmentType}/>}
                                        {(t.joinTeam || t.currentTeam )&& <Chip label={t.joinTeam || t.currentTeam || ''}/>}
                                          <Chip color={t.joinType==='ReEmployment'?'primary':'default'} label={t.joinType}/>
                                    </CardActionArea>

                                </Card>

                            </Grid>)}


                    </Grid>

                </>}

                <Divider/>
                {((!type||type==='update')&&!!updates.length)&&<>
                   <h1>{updates.length} Employment Adjustment</h1>
                    <Divider/>
                    <Grid container  spacing={2}>
                        {updates.map(t =>
                            <Grid item sm={4} xs={6}>
                                <Card fullWidth style={{cursor: 'pointer'}} onClick={() => selectCard(t,'update')} className={classnames({
                                    [classes.selected]: selectedChanges.includes(t),
                                    [classes.notFound]: notFoundTerminations.includes(t),
                                    [classes.notFoundButSelected]: selectedChanges.includes(t) && notFoundTerminations.includes(t),
                                })}>


                                    <CardHeader title={`${t.firstName || t.name} ${t.fatherName}`}
                                                subheader={t.currentTeam&&`in ${t.currentTeam}`}/>
                                    <CardContent>

                                        <Grid container direction="column">
                                            {t.updateTypes.map(ut=><Grid item>

                                                {ut==='salary'&&<>Salary Adjusted from {t.member.earning.rate} to <strong>{t.salary}</strong></>}
                                                {ut==='contractDate'&&<>Contract End changed from {moment(t.member.endDate).format('MMMM DD, YYYY')} to <strong>{moment(t.contractEndDate).format('MMMM DD, YYYY')}</strong></>}
                                            </Grid>)}
                                            <Divider style={{marginTop:20}}/>
                                            <Grid item>
                                               Effective from <strong>{moment(t.effectiveDate).format('MMMM DD, YYYY')}</strong>
                                            </Grid>
                                            <Grid item>
                                                {!!t.remark && <div>{t.remark}</div>}
                                            </Grid>
                                            <Grid item>

                                                Approved By <strong>{t.approvedBy}</strong>
                                            </Grid>
                                            <Grid item>
                                                mateId: {t.mateId || t.member.mateId}
                                            </Grid>
                                        </Grid>
                                    </CardContent>
                                    <CardActionArea>
                                        <Chip label={t.source}/>
                                    </CardActionArea>

                                </Card>

                            </Grid>)}


                    </Grid>

                </>}

                <Grid container justify="flex-end" spacing={2}>


                    <Grid item>
                        {!!selectedChanges.length && <Button style={{

                            backgroundColor: "#d95e52",

                        }} color="primary" variant="contained"
                                                                  onClick={() => onIgnore({changes: selectedChanges})}>Skip & Ignore Selected ({selectedChanges.length})</Button>}

                    </Grid>

                    <Grid item>
                        {!!selectedChanges.length  && selectedChanges.every(i=>i.type==='termination') && <Button color="primary"
                                                                  style={{

                                                                      backgroundColor: "#ffbf46",

                                                                  }}
                                                                  variant="contained"
                                                                  onClick={() => onDeactivate({changes: selectedChanges})}>Deactivate {selectedChanges.length} Employees</Button>}

                    </Grid>

                    <Grid item>
                        {!!selectedChanges.length && <Button color="primary" variant="contained"
                                                                  onClick={() => onAccept({changes: selectedChanges})}>Accept {selectedChanges.length}  Changes</Button>}
                    </Grid>
                </Grid>

            </div>


    );
};

export default SyncTikMates
